import { motion } from 'framer-motion';

import { selectHandoffPlayer, useGame } from '@/store/game';

/**
 * Проставка hotseat: телефон переезжает к следующему игроку.
 *
 * В макете этого экрана нет — он про механику, а не про зрелище, но без него
 * следующий игрок берёт телефон и видит секретное задание предыдущего.
 * Поэтому весь экран — одна зона тапа: подтверждает тот, кому передали, и
 * промахнуться в темноте невозможно.
 *
 * Состояние партии под ним уже пришло и уже лежит в сторе; показывать его
 * нельзя до подтверждения, и это решает `selectScreen`, а не разметка.
 */
export function HandoffScreen() {
  const player = useGame(selectHandoffPlayer);
  const confirm = useGame((s) => s.confirmHandoff);

  return (
    <button
      type="button"
      onClick={confirm}
      className="flex min-h-screen w-full flex-col justify-between bg-ground px-5 text-left text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <p className="pt-8 text-meta uppercase tracking-widest text-mute">Передай телефон</p>

      <div className="flex-1 py-6">
        {/* Имя влетает: экран меняется в момент, когда телефон физически едет
            по столу, и движение подсказывает, что произошло, без чтения. */}
        <motion.p
          key={player?.id ?? 'none'}
          className="font-display text-name text-acc"
          initial={{ opacity: 0, x: -12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }}
        >
          {player?.name ?? '…'}
        </motion.p>
        <p className="mt-4 text-lead text-dim">
          Остальные не смотрят: задание может оказаться секретным.
        </p>
      </div>

      <div className="border-2 border-line bg-panel px-4 py-6">
        <p className="font-display text-row">Я — {player?.name ?? 'следующий'}</p>
        <p className="mt-1 text-meta uppercase tracking-widest text-mute">Тап в любое место</p>
      </div>
    </button>
  );
}
